"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NEXT_DYNAMIC_NO_SSR_CODE = void 0;
const NEXT_DYNAMIC_NO_SSR_CODE = 'DYNAMIC_SERVER_USAGE';
exports.NEXT_DYNAMIC_NO_SSR_CODE = NEXT_DYNAMIC_NO_SSR_CODE;

//# sourceMappingURL=no-ssr-error.js.map